module.exports = __webpack_public_path__ + "static/img/answer.3ca85da2.png";